import request from './request'

export function loginApi(data) {
  return request.post('/auth/login', data)
}

export function fetchProfileApi() {
  return request.get('/auth/profile')
}
